module.exports = __webpack_public_path__ + "img/build.e87b1aee.png";